"use strict";

import autoComplete from "./autocomplete/autocomplete.js";
import autoNumeric from "./autonumeric/autonumeric.js";
import bootstrapSelect from "./bootstrap-select/bootstrap-select";
import ckeditor from "./ckeditor/ckeditor.js";
import colorpicker from "./colorpicker/colorpicker";
import confirm from "./confirm/confirm.js";
import {
  dateRangePicker,
  dateTimePicker,
  datePicker,
} from "./bootstrap-daterangepicker/bootstrap-daterangepicker.js";
import mask from "./mask/mask.js";
import maxlength from "./bootstrap-maxlength/bootstrap-maxlength.js";
import singlefileupload from "./fileupload/singlefileupload.js";
import tagsinput from "./tagsinput/tagsinput";
import toastr from "./toastr/toastr.js";

let AutoComplete = (moduleName) => {
  autoComplete.init(moduleName);
  console.log("Autocomplete loaded");
};

let AutoNumeric = (selector) => {
  autoNumeric.init(selector);
  console.log("Autonumeric loaded");
};

let BootstrapSelect = (selector) => {
  bootstrapSelect.init(selector);
  console.log("BootstrapSelect loaded");
};

let Ckeditor = (elements) => {
  ckeditor.init(elements);
  console.log("ckeditor loaded");
};

let Colorpicker = (selector) => {
  colorpicker.init(selector);
  console.log("Colorpicker loaded");
};

let Confirm = (title, content, confirmFunc, escapeFunc) => {
  confirm.init(title, content, confirmFunc, escapeFunc);
  console.log("Confirm loaded");
};

let DatePicker = (selector) => {
  datePicker(selector);
  console.log("Datepicker loaded");
};

let DateRangePicker = (selector) => {
  dateRangePicker(selector);
  console.log("daterangepicker loaded");
};

let DateTimePicker = (selector) => {
  dateTimePicker(selector);
  console.log("datetimepicker loaded");
};

let Mask = (selector) => {
  mask.init(selector);
  console.log("Mask loaded");
};

let MaxLength = () => {
  maxlength.init();
  console.log("Bootstrap maxlength loaded");
};

let SingleFileUpload = (selector, target, path, type, resetForm, randomize) => {
  singlefileupload.init(selector, target, path, type, resetForm, randomize);
  console.log("Single file upload loaded");
};

let TagsInput = (selector) => {
  tagsinput.init(selector);
  console.log("tagsinput loaded");
};

let Toastr = (type, msg) => {
  toastr.show(type, msg);
  console.log("toastr loaded");
};

export {
  AutoComplete,
  AutoNumeric,
  BootstrapSelect,
  Ckeditor,
  Colorpicker,
  Confirm,
  DatePicker,
  DateRangePicker,
  DateTimePicker,
  Mask,
  MaxLength,
  SingleFileUpload,
  TagsInput,
  Toastr,
};
